import type { MaterialComponentCategory, MaterialComponentValue, MaterialProductComponentValue } from 'api';

export const filterMaterialComponentsByCategory = <T extends MaterialComponentValue | MaterialProductComponentValue>(
  materialComponents: T[],
  category: MaterialComponentCategory
): T[] => {
  return materialComponents.filter(
    (materialComponent) => materialComponent.supported_component.component.category === category
  );
};
